import { PlusAccordionSummary } from '@components/display/accordions';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';

interface IProps {
    title: string | ReactNode;
    expanded: boolean;
    onChange: () => void;
}

export const InfoAccordion = ({ title, expanded, onChange, children }: PropsWithChildren<IProps>) => {
    return (
        <Accordion expanded={expanded} onChange={onChange} className="bg-neutral-650 p-4 px-6 rounded-xl">
            <PlusAccordionSummary isExpanded={expanded}>
                <Typography variant="h5" fontFamily="museo-sans" className="text-xl sm:text-2xl">
                    {title}
                </Typography>
            </PlusAccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    );
};
